import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Collection from "../collection/Collection";
// import Pagination from "../pagination/Pagination";
import {
  getSearchResult,
  getAdvancedSearchResult,
  cleanDataBackSearch
} from "../../actions/SearchAction";
import RenameModal from "../multi-selector-header-options/rename-modal/RenameModal";
import TagProtocolModal from "../multi-selector-header-options/tag-protocol-modal/TagProtocolModal";
import MoveModal from "../multi-selector-header-options/move-modal/MoveModal";
import DeleteModal from "../multi-selector-header-options/delete-modal/DeleteModal";
import ShareModal from "../multi-selector-header-options/share-modal/ShareModal";
import GroupModal from "../multi-selector-header-options/group-modal/GroupModal";
import DownloadModal from "../multi-selector-header-options/download-modal/DownloadModal";
import RenameFileModal from "../multi-selector-header-options/rename-file-modal/RenameFileModal";
import { individualClear } from "../../actions/IndividualSelectAction";

export class SearchResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentUrl: "",
      showPendingPaymentModal: false
    };
  }

  componentDidMount() {
    this.props.cleanDataBackSearch()
    const { workclient, searchText, searchType, isAdvancedSearchActive, advancedSearchValues} = this.props
    // limit,
    if (workclient && isAdvancedSearchActive) {
      this.props.getAdvancedSearchResult(workclient, advancedSearchValues, 1, null, 40)
    } else {
      this.props.getSearchResult(workclient, searchText, searchType, 1, null, null, 40)
    }
  }

  componentDidUpdate(prevProps) {
    const { showScrolling, pageScrolling } = this.props
    if (showScrolling && !prevProps.showScrolling) {
      this.handleChangePage(pageScrolling)
    }
  }

  handleChangePage = page => {
    const { workclient, searchText, searchType, isAdvancedSearchActive, advancedSearchValues, dataSearch } = this.props
    // limit,
    if (isAdvancedSearchActive) {
      this.props.getAdvancedSearchResult(workclient, advancedSearchValues, page, null, 40, dataSearch)
    } else {
      this.props.getSearchResult(workclient, searchText, searchType, page, null, null, 40, dataSearch)
    }
  };

  render() {
    const {
      searchText,
      intl,
      isAdvancedSearchActive,
      selectedFile,
      action
    } = this.props;
    return (
      <React.Fragment>
        <Collection
          title={
            !isAdvancedSearchActive
              ? `${intl.formatMessage({ id: "search_result" })}: ${searchText}`
              : intl.formatMessage({ id: "advanced_search_result" })
          }
          keyCollection="searcher"
        />
        {selectedFile && action === "delete" && (
          <DeleteModal
            showModal={action === "delete"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "tag_protocol" && (
          <TagProtocolModal
            showModal={action === "tag_protocol"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "rename" && (
          <RenameModal
            showModal={action === "rename"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "move" && (
          <MoveModal
            showModal={action === "move"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "group" && (
          <GroupModal
            showModal={action === "group"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "download" && (
          <DownloadModal
            showModal={action === "download"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "share" && (
          <ShareModal
            showModal={action === "share"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {selectedFile && action === "renameFile" && (
          <RenameFileModal
            showModal={action === "renameFile"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
        {/* <Pagination
          handleChangePage={this.handleChangePage}
          keyCollection="searcher"
          page={page}
          limit={limit}
          searchText={searchText}
          headers={headers}
        /> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchData: state.searcher.data,
    searchText: state.searcher.searchText,
    searchType: state.searcher.searchType,
    isFetching: state.searcher.isFetching,
    headers: state.searcher.headers,
    workclient: state.client.workclient,
    page: state.searcher.page,
    limit: state.searcher.limit,
    isAdvancedSearchActive: state.searcher.isAdvancedSearchActive,
    advancedSearchValues: state.searcher.advancedSearchValues,
    selectedFile: state.individualSelect.selectedFile,
    action: state.individualSelect.action,
    showScrolling:  state.searcher.showScrolling,
    dataSearch:  state.searcher.data,
    pageScrolling: state.searcher.pageScrolling
  };
};

const mapDispatchToProps = {
  getSearchResult,
  getAdvancedSearchResult,
  individualClear,
  cleanDataBackSearch
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchResult))
);
